import React, { useState, useEffect } from 'react';
import { X, ArrowLeft, ArrowRight, ArrowUp, Keyboard } from 'lucide-react';

const WelcomeOverlay = ({ onDismiss }) => {
    return (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-8">
            <div className="bg-white rounded-3xl max-w-2xl w-full p-12 relative">
                <button
                    onClick={onDismiss}
                    className="absolute top-6 right-6 text-gray-400 hover:text-gray-600"
                >
                    <X size={24} />
                </button>

                <div className="text-center space-y-8">
                    {/* Tagline */}
                    <div>
                        <h1 className="text-5xl font-bold text-gray-900 mb-3">
                            Tinder for Stocks
                        </h1>
                        <p className="text-xl text-gray-500">
                            Swipe through charts. Build your watchlist.
                        </p>
                    </div>

                    {/* Instructions */}
                    <div className="space-y-6 pt-8">
                        <div className="flex items-center gap-6 justify-center">
                            <div className="flex flex-col items-center gap-2">
                                <div className="w-16 h-16 rounded-full bg-red-50 flex items-center justify-center text-red-500">
                                    <ArrowLeft size={28} strokeWidth={2.5} />
                                </div>
                                <span className="text-sm font-mono text-gray-600">Pass</span>
                            </div>
                            <div className="flex flex-col items-center gap-2">
                                <div className="w-16 h-16 rounded-full bg-yellow-50 flex items-center justify-center text-yellow-500">
                                    <ArrowUp size={28} strokeWidth={2.5} />
                                </div>
                                <span className="text-sm font-mono text-gray-600">Watch</span>
                            </div>
                            <div className="flex flex-col items-center gap-2">
                                <div className="w-16 h-16 rounded-full bg-green-50 flex items-center justify-center text-green-500">
                                    <ArrowRight size={28} strokeWidth={2.5} />
                                </div>
                                <span className="text-sm font-mono text-gray-600">Trade</span>
                            </div>
                        </div>

                        {/* Keyboard Shortcuts */}
                        <div className="pt-4 border-t border-gray-100">
                            <div className="flex items-center justify-center gap-2 text-gray-400 mb-3">
                                <Keyboard size={16} />
                                <span className="text-xs font-mono">Keyboard Shortcuts</span>
                            </div>
                            <div className="flex items-center justify-center gap-8 text-sm font-mono text-gray-500">
                                <span><kbd className="px-2 py-1 bg-gray-100 rounded">←</kbd> Pass</span>
                                <span><kbd className="px-2 py-1 bg-gray-100 rounded">↑</kbd> Watch</span>
                                <span><kbd className="px-2 py-1 bg-gray-100 rounded">→</kbd> Trade</span>
                            </div>
                        </div>
                    </div>

                    {/* CTA */}
                    <button
                        onClick={onDismiss}
                        className="mt-8 px-8 py-4 bg-black text-white rounded-full font-medium hover:bg-gray-800 transition-colors"
                    >
                        Start Swiping
                    </button>
                </div>
            </div>
        </div>
    );
};

export default WelcomeOverlay;
